import { useTranslation } from 'react-i18next';
import { type PanelProps } from './types';

function extractSurfaceKey(payload: unknown): string {
  if (payload && typeof payload === 'object' && 'surfaceKey' in payload) {
    const v = (payload as { surfaceKey?: unknown }).surfaceKey;
    if (typeof v === 'string') return v;
  }
  return 'unknown';
}

export function FallbackSurface({ payload, onClose }: PanelProps) {
  const { t } = useTranslation('common');
  const surfaceKey = extractSurfaceKey(payload);

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 p-6 text-center">
      <p className="text-sm text-muted-foreground">
        {t('fallback.message', {
          defaultValue: `Surface '{{key}}' isn't available yet.`,
          key: surfaceKey,
        })}
      </p>
      <button
        type="button"
        onClick={onClose}
        className="rounded-md border border-border px-3 py-1.5 text-sm hover:bg-muted focus:outline-none focus:ring-2 focus:ring-ring"
      >
        {t('fallback.backToChat', { defaultValue: 'Back to chat' })}
      </button>
    </div>
  );
}
